import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { SparklinesBars, SparklinesLine, Sparklines } from "react-sparklines";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BgCard } from "../../elements/CardDesign";
import { IMAGES, SVGICON } from "../../constant/theme";
import CkEditorBlog from "../../elements/CkEditor/CkEditorBlog";
import {
  getDashboardSummary,
  getHighDemandPackages,
  getOverDueSummary,
  getPackagesByPayments,
  getPackageSummary,
  getPaymentModeSummary,
  getRegistrationSummary,
  getRemidersSent,
  getUpcomingDues,
} from "../../../services/academicService";
import ExpenseAreaChart from "../../elements/dashboard/ExpenseAreaChart";
import DefaultCard from "../widget/DefaultCard";
import { formatDateToApi } from "../../../utils/dateUtils";
import {
  TotalPlayersModal,
  ActivePackagesModal,
  TotalCollectionModal,
  RegistrationSummaryModal,
  PackagePurchaseModal,
  HighDemandPackagesModal,
  PackagePaymentModal,
  UpcomingRenewalsModal,
  NoRenewalsModal,
  RemindersSentModal,
  PaymentModeModal,
} from "../../components/dashboard-modal";

//Charts
const SurveyChart = loadable(() =>
  pMinDelay(import("../../elements/dashboard/SurveyChart"), 500),
);
const DonughtChart = loadable(() =>
  pMinDelay(import("../../elements/dashboard/DonughtChart"), 500),
);
const University = loadable(() =>
  pMinDelay(import("../../elements/dashboard/University"), 500),
);

const bgCarddBlog = [
  {
    title: "Total Students",
    number: "3180",
    icon: <i className="la la-users" />,
    percent: "80%",
    color: "primary",
  },
  {
    title: "New Students",
    number: "360",
    icon: <i className="la la-user" />,
    percent: "50%",
    color: "warning",
  },
  {
    title: "Total Course",
    number: "28",
    icon: <i className="la la-graduation-cap" />,
    percent: "60%",
    color: "secondary",
  },
  {
    title: "Fees Collection",
    number: "1290$",
    icon: <i className="la la-dollar" />,
    percent: "35%",
    color: "danger",
  },
];

const detailCard = [
  {
    title: "When Is the Best Time to Take an Education Course?",
    name: "Jack Ronan",
    image: IMAGES.course1,
  },
  {
    title: "Education Courses: A Guide to Unlocking Your Potential",
    name: "Jimmy Morris",
    image: IMAGES.course2,
  },
  {
    title: "A Comprehensive Guide to Taking an Education Course",
    name: "Konne Backfield",
    image: IMAGES.course3,
  },
  {
    title: "Why Should You Consider Taking an Education Course?",
    name: "Nashid Martines",
    image: IMAGES.course4,
  },
];

const examTable = [
  { roll: "542", name: " Jack Ronan" },
  { roll: "360", name: "Jimmy Morris" },
  { roll: "450", name: "Samantha" },
  { roll: "296", name: "Roman Aurora" },
  { roll: "520", name: "Nashid Martines" },
  { roll: "620", name: "Daigno" },
];

const tabelData = [
  {
    no: "01",
    name: "Jack Ronan",
    proff: "Airi Satou",
    date: "02 jan 2024",
    status: "Checkin",
    color: "primary",
    subject: "Commerce",
    fees: "120",
  },
  {
    no: "02",
    name: "Jimmy Morris",
    proff: "Angelica Ramos",
    date: "02 jan 2024",
    status: "Pending",
    color: "warning",
    subject: "Mechanical",
    fees: "205",
  },
  {
    no: "03",
    name: "Nashid Martines",
    proff: "Ashton Cox",
    date: "04 jan 2024",
    status: "Canceled",
    color: "danger",
    subject: "Science",
    fees: "180",
  },
  {
    no: "04",
    name: "Roman Aurora",
    proff: "Cara Stevens",
    date: "05 jan 2024",
    status: "Process",
    color: "info",
    subject: "Arts",
    fees: "200",
  },
  {
    no: "05",
    name: "Samantha",
    proff: "Bruno Nash",
    date: "06 jan 2024",
    status: "Checkin",
    color: "primary",
    subject: "Maths",
    fees: "210",
  },
];

const Home = () => {
  const dashboardRef = useRef(null);
  const [dashboardStats, setDashboardStats] = useState({});
  const [registrationSummary, setRegistrationSummary] = useState({
    totalPackagesPurchased: 0,
    graph: [],
  });
  const getDefaultDateRange = () => {
    const today = new Date();
    const start = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      today.getDate(),
    );
    return { start, end: today };
  };
  const [dateRange] = useState(getDefaultDateRange());
  const [startDate, setStartDate] = useState(dateRange.start);
  const [endDate, setEndDate] = useState(dateRange.end);
  const [isFiltering, setIsFiltering] = useState(false);
  const [packageSummary, setPackageSummary] = useState({
    totalPackagesPurchased: 0,
    graph: [],
  });
  const [highDemandPackages, setHighDemandPackages] = useState({});
  const [packagePaymentData, setPackagePaymentData] = useState({});
  const [upcomingDues, setUpcomingDues] = useState({});
  const [overDueSummary, setOverDueSummary] = useState({});
  const [remendersSent, setRemendersSent] = useState({});
  const [paymentMode, setPaymentMode] = useState({});

  // Dashboard Modals
  const [showTotalPlayersModal, setShowTotalPlayersModal] = useState(false);
  const [showActivePackagesModal, setShowActivePackagesModal] = useState(false);
  const [showTotalCollectionModal, setShowTotalCollectionModal] = useState(false);
  const [showRegModal, setShowRegModal] = useState(false);
  const [showPackagePurchaseModal, setShowPackagePurchaseModal] = useState(false);
  const [showHighDemandModal, setShowHighDemandModal] = useState(false);
  const [showPackagePaymentModal, setShowPackagePaymentModal] = useState(false);
  const [showUpcomingRenewalsModal, setShowUpcomingRenewalsModal] = useState(false);
  const [showNoRenewalsModal, setShowNoRenewalsModal] = useState(false);
  const [showRemindersSentModal, setShowRemindersSentModal] = useState(false);
  const [showPaymentModeModal, setShowPaymentModeModal] = useState(false);

  const handlePrintDashboard = () => {
    window.print();
  };

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") return "0";

    const num = Number(value);

    const format = (n, suffix) => {
      const val = parseFloat(n.toFixed(1));
      return `${val}${suffix}`;
    };

    if (num >= 10000000) {
      return format(num / 10000000, "Cr");
    }

    if (num >= 100000) {
      return format(num / 100000, "L");
    }

    if (num >= 1000) {
      return format(num / 1000, "K");
    }

    return num.toString();
  };

  const fetchDashboardSummary = async () => {
    try {
      const res = await getDashboardSummary();
      if (res) {
        setDashboardStats(res || null);
      }
    } catch (error) {
      console.error("Error fetching overview data:", error);
    }
  };

  const fetchUpcomingDues = async () => {
    try {
      const res = await getUpcomingDues();
      if (res) {
        setUpcomingDues(res || null);
      }
    } catch (error) {
      console.error("Error fetching overview data:", error);
    }
  };

  const fetchOverDueSummary = async () => {
    try {
      const res = await getOverDueSummary();
      if (res) {
        setOverDueSummary(res || null);
      }
    } catch (error) {
      console.error("Error fetching overview data:", error);
    }
  };

  const fetchRemidersSent = async () => {
    try {
      const res = await getRemidersSent();
      if (res) {
        setRemendersSent(res || null);
      }
    } catch (error) {
      console.error("Error fetching overview data:", error);
    }
  };

  const fetchPaymentModeSummary = async () => {
    try {
      const res = await getPaymentModeSummary();
      if (res) {
        setPaymentMode(res || null);
      }
    } catch (error) {
      console.error("Error fetching overview data:", error);
    }
  };

  const fetchFilteredDashboardData = async () => {
    const fromDate = formatDateToApi(startDate);
    const toDate = formatDateToApi(endDate);

    setIsFiltering(true);

    try {
      const [registrationRes, packageRes, highDemandRes, paymentRes] =
        await Promise.all([
          getRegistrationSummary(fromDate, toDate),
          getPackageSummary(fromDate, toDate),
          getHighDemandPackages(fromDate, toDate),
          getPackagesByPayments(fromDate, toDate),
        ]);

      setRegistrationSummary(
        registrationRes || { totalRegistrations: 0, graph: [] },
      );
      setPackageSummary(packageRes || { totalPackagesPurchased: 0, graph: [] });
      setHighDemandPackages(highDemandRes || {});
      setPackagePaymentData(paymentRes || {});
    } catch (error) {
      console.error("Error fetching filtered dashboard data:", error);
      setRegistrationSummary({ totalRegistrations: 0, graph: [] });
      setPackageSummary({ totalPackagesPurchased: 0, graph: [] });
      setHighDemandPackages({});
      setPackagePaymentData({});
    } finally {
      setIsFiltering(false);
    }
  };

  useEffect(() => {
    fetchDashboardSummary();
    fetchUpcomingDues();
    fetchOverDueSummary();
    fetchRemidersSent();
    fetchPaymentModeSummary();
  }, []);

  useEffect(() => {
    fetchFilteredDashboardData();
  }, [startDate, endDate]);

  const handleResetFilter = () => {
    const defaultRange = getDefaultDateRange();
    setStartDate(defaultRange.start);
    setEndDate(defaultRange.end);
  };

  const previousMonthName = new Date(
    new Date().getFullYear(),
    new Date().getMonth() - 1,
  ).toLocaleString("default", { month: "short" });

  const cardBlog = [
    {
      title: "Total Players",
      number: dashboardStats?.totalPlayers,
      icon: SVGICON.user,
      percent: `+${dashboardStats?.playersGrowth || "0"} this month`,
      color: "primary",
    },
    {
      title: "Active Packages",
      number: dashboardStats?.activePackages,
      icon: SVGICON.bills,
      percent: `+${dashboardStats?.packagesGrowth || "0"} this month`,
      color: "warning",
    },
    {
      title: "Total Collection",
      number: `₹${formatAmount(dashboardStats?.totalCollection)}`,
      icon: SVGICON.revenue,
      percent: `${dashboardStats?.collectionGrowth || "0"}% Vs ${previousMonthName}`,
      color: "danger",
    },
    {
      title: "Upcoming Renewals",
      number: dashboardStats?.upcomingRenewals,
      icon: SVGICON.grid,
      percent: `₹${formatAmount(dashboardStats?.upcomingRenewalAmount)}`,
      color: "success",
    },
  ];

  const upcomingRenewalRows = [
    {
      label: "Within 7 Days",
      count: upcomingDues?.within7Days?.count,
      amount: upcomingDues?.within7Days?.amount,
    },
    {
      label: "8 - 15 Days",
      count: upcomingDues?.eightToFifteenDays?.count,
      amount: upcomingDues?.eightToFifteenDays?.amount,
    },
    {
      label: "16 - 30 Days",
      count: upcomingDues?.sixteenToThirtyDays?.count,
      amount: upcomingDues?.sixteenToThirtyDays?.amount,
    },
    {
      label: "30+ Days",
      count: upcomingDues?.thirtyPlusDays?.count,
      amount: upcomingDues?.thirtyPlusDays?.amount,
    },
  ];

  const upcomingNoRenewalRows = [
    {
      label: "1 - 15 Days Overdue",
      count: overDueSummary?.oneToFifteenDays?.count,
      amount: overDueSummary?.oneToFifteenDays?.amount,
    },
    {
      label: "16 - 30 Days Overdue",
      count: overDueSummary?.sixteenToThirtyDays?.count,
      amount: overDueSummary?.sixteenToThirtyDays?.amount,
    },
    {
      label: "31 - 60 Days Overdue",
      count: overDueSummary?.sixtyPlusDays?.count,
      amount: overDueSummary?.sixtyPlusDays?.amount,
    },
    {
      label: "60+ Days Overdue",
      count: overDueSummary?.thirtyOneToSixtyDays?.count,
      amount: overDueSummary?.thirtyOneToSixtyDays?.amount,
    },
  ];

  const reminderSentRows = [
    {
      label: "Today",
      count: remendersSent?.today?.count,
      amount: remendersSent?.today?.amount,
    },
    {
      label: "This Week",
      count: remendersSent?.thisWeek?.count,
      amount: remendersSent?.thisWeek?.amount,
    },
    {
      label: "This Month",
      count: remendersSent?.thisMonth?.count,
      amount: remendersSent?.thisMonth?.amount,
    },
  ];

  return (
    <>
      <style>{`
        @media print {
          @page {
            size: A4 landscape;
            margin: 10mm;
          }

          html, body {
            height: auto !important;
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: visible !important;
          }

          body * {
            visibility: hidden !important;
          }

          /* The app's own layout (sidebar / content wrapper) constrains
             #dashboard-print-area to a narrow column on screen. Any
             ancestor with position: relative/absolute/fixed becomes a
             new "containing block" that keeps limiting our width even
             after we set position:absolute below — so force every
             element to position:static first, removing all of those
             containing blocks, then give the print area itself
             position:absolute so it sizes against the full page instead
             of the app's narrow content column. */
          * {
            position: static !important;
          }

          #dashboard-print-area,
          #dashboard-print-area * {
            visibility: visible !important;
          }

          #dashboard-print-area {
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
            right: 0 !important;
            margin: 0 auto !important;
            width: 100% !important;
            max-width: none !important;
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
          }

          /* Never let anything hide overflow content in print */
          #dashboard-print-area *,
          #dashboard-print-area .card,
          #dashboard-print-area .card-body,
          #dashboard-print-area .table-responsive,
          #dashboard-print-area .recentOrderTable {
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
          }

          #dashboard-print-area .no-print {
            display: none !important;
          }

          /* Let cards break across pages instead of being clipped,
             but avoid splitting a card right at its header/first row
             when it reasonably fits on one page */
          #dashboard-print-area .card {
            break-inside: avoid-page;
            page-break-inside: avoid;
            box-shadow: none !important;
            border: 1px solid #dee2e6 !important;
            margin-bottom: 12px !important;
          }

          /* If a card's table is too long to fit without splitting,
             allow the table itself to break across pages row by row
             instead of getting cut off / hidden */
          #dashboard-print-area .table-responsive table {
            page-break-inside: auto;
          }
          #dashboard-print-area table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
          #dashboard-print-area table thead {
            display: table-header-group;
          }

          /* Reset Bootstrap's grid for print. The dashboard below is
             now structured as several small <Row> groups (4 stat cards,
             then each chart/table pair in its own row) so that pairing
             stays fixed — e.g. Registration Summary always sits next to
             Package Purchase. Force each row into a strict 2-column
             layout regardless of the on-screen xl/lg/sm classes, since
             the print page width doesn't reliably match the same
             Bootstrap breakpoint as the screen. */
          #dashboard-print-area .row {
            display: flex !important;
            flex-wrap: wrap !important;
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
          }

          #dashboard-print-area .row > * {
            display: block !important;
            box-sizing: border-box !important;
            flex: 0 0 50% !important;
            width: 50% !important;
            max-width: 50% !important;
            margin: 0 !important;
            padding: 6px !important;
            break-inside: avoid !important;
            page-break-inside: avoid !important;
          }

          /* The date filter bar is hidden in print anyway (.no-print) */
          #dashboard-print-area .row > .no-print {
            display: none !important;
          }

          #dashboard-print-area table {
            width: 100% !important;
          }

          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
        }
      `}</style>

      <div ref={dashboardRef} id="dashboard-print-area">
        {/* Row 1: 4 stat cards — 2 cards per row (2 rows) */}
        <Row>
          {cardBlog?.map((item, index) => (
            <Col xl={6} sm={6} key={index}>
              <div
                className="widget-stat card shadow-sm position-relative"
                style={{ cursor: "pointer", transition: "all 0.2s ease-in-out" }}
                title={`Click to view ${item.title} details`}
                onClick={() => {
                  if (index === 0) setShowTotalPlayersModal(true);
                  else if (index === 1) setShowActivePackagesModal(true);
                  else if (index === 2) setShowTotalCollectionModal(true);
                  else if (index === 3) setShowUpcomingRenewalsModal(true);
                }}
              >
                <div className="card-body p-4 d-flex align-items-center justify-content-between">
                  <DefaultCard
                    title={item.title}
                    number={item.number}
                    percent={item.percent}
                    icon={item.icon}
                    color={item.color}
                  />
                  <div className="ms-3 pe-2">
                    <i className="fas fa-chevron-right fs-18 text-dark" style={{ opacity: 0.7 }}></i>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* Date filter bar — hidden in print */}
        <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap mb-4 no-print">
          <div className="d-flex align-items-center gap-2">
            <label className="form-label mb-0">From</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => {
                setStartDate(date);
                setEndDate(null);
              }}
              maxDate={new Date()}
              dateFormat="yyyy-MM-dd"
              className="form-control form-control-sm"
              placeholderText="Start date"
            />
          </div>

          <div className="d-flex align-items-center gap-2">
            <label className="form-label mb-0">To</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              minDate={startDate}
              maxDate={new Date()}
              disabled={!startDate}
              dateFormat="yyyy-MM-dd"
              className="form-control form-control-sm"
              placeholderText="End date"
            />
          </div>

          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={handleResetFilter}
            disabled={isFiltering}
          >
            Reset
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handlePrintDashboard}
          >
            <i className="la la-print me-1" />
            Print
          </button>
        </div>

        {/* Row 2: Registration Summary + Package Purchase, same row */}
        <Row>
          <Col xl={6} sm={6}>
            <div
              className="card shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => setShowRegModal(true)}
              title="Click to view registration details"
            >
              <div className="card-header d-flex justify-content-between align-items-center">
                <div>
                  <h3 className="card-title mb-0">Registration Summary</h3>
                  <small className="text-muted">(Date wise)</small>
                </div>
                <i className="fas fa-chevron-right fs-18 text-dark" style={{ opacity: 0.7 }}></i>
              </div>

              <div className="card-body">
                <ExpenseAreaChart
                  total={registrationSummary.totalRegistrations}
                  graph={registrationSummary.graph}
                />
              </div>
            </div>
          </Col>

          <Col xl={6} sm={6}>
            <div
              className="card shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => setShowPackagePurchaseModal(true)}
              title="Click to view package purchase details"
            >
              <div className="card-header d-flex justify-content-between align-items-center">
                <div>
                  <h3 className="card-title mb-0">Packages Purchased</h3>
                  <small className="text-muted">(Date wise)</small>
                </div>
                <i className="fas fa-chevron-right fs-18 text-dark" style={{ opacity: 0.7 }}></i>
              </div>

              <div className="card-body">
                <ExpenseAreaChart
                  total={packageSummary.totalPackagesPurchased}
                  graph={packageSummary.graph}
                />
              </div>
            </div>
          </Col>
        </Row>

        {/* Row 3: High Demand Packages + Package Wise Payment Collected */}
        <Row>
          <Col xl={6} sm={6}>
            <div
              className="card shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => setShowHighDemandModal(true)}
              title="Click to view high demand packages"
            >
              <div className="card-header d-flex justify-content-between align-items-center">
                <h3 className="card-title mb-0">High Demand Packages</h3>
                <i className="fas fa-chevron-right fs-18 text-dark" style={{ opacity: 0.7 }}></i>
              </div>
              <div className="card-body">
                <DonughtChart
                  data={highDemandPackages.packages}
                  total={highDemandPackages.totalPlayers}
                />
              </div>
            </div>
          </Col>

          <Col xl={6} sm={6}>
            <div
              className="card shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => setShowPackagePaymentModal(true)}
              title="Click to view payment collected details"
            >
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Package Wise Payment Collected</h4>
                <i className="fas fa-chevron-right fs-18 text-dark" style={{ opacity: 0.7 }}></i>
              </div>

              <div className="card-body pt-2">
                <div className="table-responsive recentOrderTable">
                  <table className="table verticle-middle text-nowrap table-responsive-md">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Package</th>
                        <th className="text-end">Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {packagePaymentData?.packages?.map((item, index) => (
                        <tr key={item.packageId}>
                          <td>{index + 1}</td>
                          <td>{item.packageName}</td>
                          <td className="text-end">
                            ₹ {formatAmount(item.amountCollected)}(
                            {item.percentage}%)
                          </td>
                        </tr>
                      ))}

                      {/* Total Row */}
                      {packagePaymentData && (
                        <tr className="fw-bold border-top">
                          <td colSpan={2}>Total</td>
                          <td className="text-end">
                            ₹
                            {formatAmount(
                              packagePaymentData?.totalAmountCollected,
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Row 4: Upcoming Renewals/Dues + No Renewals/Dues not Paid */}
        <Row>
          <Col xl={6} sm={6}>
            <div
              className="card shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => setShowUpcomingRenewalsModal(true)}
              title="Click to view upcoming renewals"
            >
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Upcoming Renewals / Dues</h4>
                <i className="fas fa-chevron-right fs-18 text-dark" style={{ opacity: 0.7 }}></i>
              </div>

              <div className="card-body pt-2">
                <div className="table-responsive">
                  <table className="table table-borderless align-middle">
                    <thead>
                      <tr>
                        <th>Duration</th>
                        <th className="text-center">Package</th>
                        <th className="text-end">Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {upcomingRenewalRows.map((item, index) => (
                        <tr key={index}>
                          <td>{item.label}</td>

                          <td className="text-center fw-semibold">
                            {item.count}
                          </td>

                          <td className="text-end fw-semibold">
                            ₹ {formatAmount(item.amount)}
                          </td>
                        </tr>
                      ))}

                      <tr
                        style={{
                          borderTop: "2px solid #dee2e6",
                          fontWeight: 700,
                          color: "#198754",
                        }}
                      >
                        <td>TOTAL</td>

                        <td className="text-center">
                          {upcomingDues?.totalCount}
                        </td>

                        <td className="text-end">
                          ₹ {formatAmount(upcomingDues?.totalAmount)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Col>

          <Col xl={6} sm={6}>
            <div
              className="card shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => setShowNoRenewalsModal(true)}
              title="Click to view overdue / no renewals"
            >
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">No Renewals / Dues not Paid</h4>
                <i className="fas fa-chevron-right fs-18 text-dark" style={{ opacity: 0.7 }}></i>
              </div>

              <div className="card-body pt-2">
                <div className="table-responsive">
                  <table className="table table-borderless align-middle">
                    <thead>
                      <tr>
                        <th>Duration</th>
                        <th className="text-center">Package</th>
                        <th className="text-end">Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {upcomingNoRenewalRows.map((item, index) => (
                        <tr key={index}>
                          <td>{item.label}</td>

                          <td className="text-center fw-semibold">
                            {item.count}
                          </td>

                          <td className="text-end fw-semibold">
                            ₹ {formatAmount(item.amount)}
                          </td>
                        </tr>
                      ))}

                      <tr
                        style={{
                          borderTop: "2px solid #dee2e6",
                          fontWeight: 700,
                          color: "#198754",
                        }}
                      >
                        <td>TOTAL</td>

                        <td className="text-center">
                          {overDueSummary?.totalCount}
                        </td>

                        <td className="text-end">
                          ₹ {formatAmount(overDueSummary?.totalAmount)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Row 5: Reminders Sent + Mode & Payments */}
        <Row>
          <Col xl={6} sm={6}>
            <div
              className="card shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => setShowRemindersSentModal(true)}
              title="Click to view sent reminders"
            >
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Reminders Sent</h4>
                <i className="fas fa-chevron-right fs-18 text-dark" style={{ opacity: 0.7 }}></i>
              </div>

              <div className="card-body pt-2">
                <div className="table-responsive">
                  <table className="table table-borderless align-middle">
                    <thead>
                      <tr>
                        <th>Duration</th>
                        <th className="text-center">Players</th>
                        <th className="text-end">Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {reminderSentRows.map((item, index) => (
                        <tr key={index}>
                          <td>{item.label}</td>

                          <td className="text-center fw-semibold">
                            {item.count || 0}
                          </td>

                          <td className="text-end fw-semibold">
                            ₹ {formatAmount(item.amount) || 0}
                          </td>
                        </tr>
                      ))}

                      <tr
                        style={{
                          borderTop: "2px solid #dee2e6",
                          fontWeight: 700,
                          color: "#198754",
                        }}
                      >
                        <td>TOTAL</td>

                        <td className="text-center">
                          {remendersSent?.total?.count || 0}
                        </td>

                        <td className="text-end">
                          ₹ {formatAmount(remendersSent?.total?.amount)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Col>

          <Col xl={6} sm={6}>
            <div
              className="card shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => setShowPaymentModeModal(true)}
              title="Click to view payment mode details"
            >
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Mode & Payments</h4>
                <i className="fas fa-chevron-right fs-18 text-dark" style={{ opacity: 0.7 }}></i>
              </div>

              <div className="card-body pt-2">
                <div className="table-responsive">
                  <table className="table table-borderless align-middle">
                    <thead>
                      <tr>
                        <th>Payment Mode</th>
                        <th className="text-center">Package</th>
                        <th className="text-end">Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {paymentMode?.paymentModes?.map((item, index) => (
                        <tr key={index}>
                          <td>{item.paymentMode}</td>

                          <td className="text-center fw-semibold">
                            {item.count}
                          </td>

                          <td className="text-end fw-semibold">
                            ₹ {formatAmount(item.amount)}
                          </td>
                        </tr>
                      ))}

                      <tr
                        style={{
                          borderTop: "2px solid #dee2e6",
                          fontWeight: 700,
                          color: "#198754",
                        }}
                      >
                        <td>TOTAL</td>

                        <td className="text-center">
                          {formatAmount(paymentMode?.totalCount)}
                        </td>

                        <td className="text-end">
                          ₹ {formatAmount(paymentMode?.totalAmount)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {/* Dashboard Modals */}
      <TotalPlayersModal
        show={showTotalPlayersModal}
        onHide={() => setShowTotalPlayersModal(false)}
      />
      <ActivePackagesModal
        show={showActivePackagesModal}
        onHide={() => setShowActivePackagesModal(false)}
      />
      <TotalCollectionModal
        show={showTotalCollectionModal}
        onHide={() => setShowTotalCollectionModal(false)}
      />
      <RegistrationSummaryModal
        show={showRegModal}
        onHide={() => setShowRegModal(false)}
        startDate={startDate}
        endDate={endDate}
      />
      <PackagePurchaseModal
        show={showPackagePurchaseModal}
        onHide={() => setShowPackagePurchaseModal(false)}
        startDate={startDate}
        endDate={endDate}
      />
      <HighDemandPackagesModal
        show={showHighDemandModal}
        onHide={() => setShowHighDemandModal(false)}
        packagesData={highDemandPackages?.packages}
        totalPlayers={highDemandPackages?.totalPlayers}
      />
      <PackagePaymentModal
        show={showPackagePaymentModal}
        onHide={() => setShowPackagePaymentModal(false)}
        startDate={startDate}
        endDate={endDate}
        packagePaymentData={packagePaymentData}
      />
      <UpcomingRenewalsModal
        show={showUpcomingRenewalsModal}
        onHide={() => setShowUpcomingRenewalsModal(false)}
        startDate={startDate}
        endDate={endDate}
      />
      <NoRenewalsModal
        show={showNoRenewalsModal}
        onHide={() => setShowNoRenewalsModal(false)}
        startDate={startDate}
        endDate={endDate}
      />
      <RemindersSentModal
        show={showRemindersSentModal}
        onHide={() => setShowRemindersSentModal(false)}
        startDate={startDate}
        endDate={endDate}
      />
      <PaymentModeModal
        show={showPaymentModeModal}
        onHide={() => setShowPaymentModeModal(false)}
        startDate={startDate}
        endDate={endDate}
      />
    </>
  );
};
export default Home;
